import React__default from 'react';
import { SvgImg } from '../../components/svgImg/svgImg.js';

const Dot = ({ width = '4px', height = '4px', fill = '#686868' }) => (React__default.createElement(SvgImg, { title: 'Dot', viewbox: '0 0 4 4', width: width, height: height, fill: fill },
    React__default.createElement("svg", { width: "4", height: "4", viewBox: "0 0 4 4", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("circle", { id: "Dot", cx: "2", cy: "2", r: "2", fill: '#686868' }))));

export { Dot };
